import { render } from "./CustomPropertiesInput.vue?vue&type=template&id=4eeac884"
import script from "./CustomPropertiesInput.vue?vue&type=script&lang=js"
export * from "./CustomPropertiesInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__